import { render, staticRenderFns } from "./UnityApp.vue?vue&type=template&id=768c3924&scoped=true"
import script from "./UnityApp.vue?vue&type=script&lang=js"
export * from "./UnityApp.vue?vue&type=script&lang=js"
import style0 from "./UnityApp.vue?vue&type=style&index=0&id=768c3924&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768c3924",
  null
  
)

export default component.exports